import { Box, SxProps, Theme, useTheme } from '@mui/material';


export const Section = (props: { children: React.ReactNode, style?: SxProps<Theme>, onClick?: () => void }) => {
  const theme = useTheme();
  return (
    <Box
      onClick={props.onClick}
      sx={{
        border: '1px solid',
        boxShadow: '0 1px 2px 1px #1018280D',
        borderRadius: '12px',
        borderColor: theme.palette.custom.gray[300],
        overflow: 'hidden',
        ...(props.style ?? {}),
      }}
    >
      {props.children}
    </Box >
  );
};

